// DonutChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

//import resize function
import {vw,vh} from "../../../assets/reusableComponents/resizeFunction"


// Register components with ChartJS
ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ percentage, donutSize,setColors }) => {
  let myColor = "";

  if (!setColors) {
    if (percentage < 26) {
      myColor = "#B99963";
    } else if (percentage < 51) {
      myColor = "#64A371";
    } else if (percentage < 76) {
      myColor = "#377771";
    } else if (percentage < 100) {
      myColor = "#293947";
    }
  }

  // Ensure percentage is within 0-100
  const validPercentage = Math.min(Math.max(percentage, 0), 100);

  // Chart data
  const data = {
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        label: "Progress",
        data: [validPercentage, 100 - validPercentage], // Set data based on the percentage prop
        backgroundColor: setColors?[setColors[0],setColors[1]]:  [`${myColor}`, "#DCDCDC"],
        hoverBackgroundColor:setColors?[setColors[0],setColors[1]]:  [`${myColor}`, "#DCDCDC"],
        borderWidth: 0,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    cutout: donutSize ? donutSize : "80%", // Makes the chart look like a donut
    plugins: {
      tooltip: {
        enabled: false, // Disable default tooltips
        
      },
      legend: {
        display: false, // Disable legend display
      },
    },
    maintainAspectRatio: false, // Allow custom width and height
  };

  // Custom text display in the center
  const plugins = [
    {
      id: "textDisplay",
      beforeDraw: (chart) => {
        const { width, height, ctx } = chart;
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = "middle";

        const text = `${validPercentage}%`; // Display the percentage prop value
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    },
  ];

  return (
    <div style={{ width: vh(100), height: vh(100),}}>
      {" "}
      {/* Set custom dimensions here */}
      <Doughnut data={data} options={options} plugins={plugins}   key={validPercentage} />
    </div>
  );
};

export default DonutChart;
